module.exports = __webpack_public_path__ + "static/media/NCR.83e50e98.jpeg";